import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  render() {
    if (this.props.isActive) {
      return (
        <li className="col-md-3 col-sm-3 col-xs-4 photo-list">
          <div className="photo-wrap">
            <a
              className="photo-h"
              style={{ textAlign: "center", color: "#ccc" }}
            >
              <i className="fas fa-spinner fa-pulse fa-2x fa-fw" />
            </a>
          </div>
        </li>
      );
    } else {
      return null;
    }
  },
});
